import * as React from "react";
import Card from "../components/Card";
import { useState, useEffect } from "react";

export interface LocationProps {}

const entity = "wowviewpoint";
const domain = "gmail";
const tld = "com";
const emD = ".";
const emA = "@";

const PIXEL_RATIO = (() => {
  const ctx: any = document.createElement("canvas").getContext("2d");
  const dpr = window.devicePixelRatio || 1;
  const bsr =
    ctx.webkitBackingStorePixelRatio ||
    ctx.mozBackingStorePixelRatio ||
    ctx.msBackingStorePixelRatio ||
    ctx.oBackingStorePixelRatio ||
    ctx.backingStorePixelRatio ||
    1;

  return dpr / bsr;
})();

const Location: React.FC<LocationProps> = (props) => {
  const locationHeight = 429;
  const canvasRef = React.useRef(null);
  const isEmail = false;

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const text = `You can contact us at: ${entity}${emA}${domain}${emD}${tld}`;

    const canvasFontSize = window
      .getComputedStyle(document.body, null)
      .getPropertyValue("font-size"); // e.g. 16px
    context.font = `${canvasFontSize} Gill Sans`;
    canvas.width = context.measureText(text).width * PIXEL_RATIO;

    console.log(canvas.width);

    canvas.height = parseInt(canvasFontSize) * PIXEL_RATIO;

    canvas.style.width = `${canvas.width / PIXEL_RATIO}px`;

    canvas.style.height = `${parseInt(canvasFontSize)}px`;
    context.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0);
    context.clearRect(0, 0, canvas.width, canvas.height);

    // console.log(
    //   text,
    //   canvasFontSize,
    //   canvas.width,
    //   canvas.height,
    //   context.font
    // );

    context.fillStyle = "#000000";
    context.font = `${canvasFontSize} Gill Sans`; // for some reason context.font was reset, so I'm setting it back again
    context.textBaseline = "top";
    context.fillText(text, 0, 0);
  });

  console.log(canvasRef);

  return (
    <div>
      <Card title="Location" titleBackgroundColor="#FCBA6A">
        <p>
          The easiest way to find the bar is to find Baan Klong's Guesthouse via
          Google Maps and go up the road from there.
        </p>
        {isEmail && <span id="email">wvpcontactinfo@gmail.com</span>}
        {/* hack: because I can't get it to work with margin or padding. Need to fix later */}
        <div
          style={{
            height: 16 / 2,
            width: 1,
            border: "0px solid red",
          }}
        />
        <canvas
          id="em"
          style={{ display: "inline-block" }}
          ref={canvasRef}
        ></canvas>
        <br />
        {/* <p>
          It is quite a hike going to 150 meters altitude. You have been warned
          😉
        </p> */}
      </Card>

      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          margin: 0,
          padding: 0,
          zIndex: -1,
          width: "100%",
          height: `${locationHeight}px`,
          backgroundImage: "url('img/location.png')",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    </div>
  );
};

export default Location;
